import * as BILLING_CYCLES from "constants/billingCycles";
import { ITEM_TYPES } from "constants/productAndServices";
import { ItemType } from "types/Models/productAndServices";
import {
  ADMIN_APPROVED,
  INITIATED,
  NOT_INITIATED,
  REJECTED_REQUEST,
} from "./constants/groupRequest";

import AmEx from "static/images/Amex.svg";
import DefaultBankLogo from "static/images/DefaultBankLogo.svg";
import Discover from "static/images/Discover.svg";
import JCB from "static/images/JCB.svg";
import MasterCard from "static/images/Mastercard.svg";
import UnionPay from "static/images/UnionPay.svg";
import Visa from "static/images/Visa.svg";
import { MONTHLY, QUARTERLY, YEARLY } from "constants/billingCycles";

import {
  FILING_IN_PROGRESS,
  FORM_FILING,
  REVIEW,
  SUBMITTED,
  UPLOAD_DOCUMENTS,
} from "./constants/taskStates";
import { NOT_STARTED } from "./constants/taskStatus";

import {
  ACCOUNTING_METHODS,
  ASSET,
  BALANCE_SHEET,
  CASH_FLOW_STATEMENT,
  EQUITY,
  EXPENSE,
  INCOME_STATEMENT,
  LIABILITY,
  REVENUE,
  SAVED_REPORTS,
} from "constants/bookkeeping";
import * as BOOKKEEPIN_SUMMAY_STATUSES from "constants/bookkeepingMonthlySummaryStatus";
import {
  REPLY_REQUEST_TXN_INVOICE,
  REPLY_TXN_CLARIFICATION_CARD,
  REQUEST_TXN_INVOICE,
  TXN_CLARIFICATION_CARD,
} from "constants/messageTypes";
import {
  INVITED,
  PENDING,
  SENT,
  SIGNED_UP,
  SUBSCRIBED,
} from "constants/referral";
import {
  BYOA,
  FREE_PLAN,
  PAYG,
  PRO,
  PRO_PLAN,
  STANDARD,
  STANDARD_PLAN,
  FREE,
  UNSUBSCRIBED,
  RA,
  MAILROOM,
  MONTHLY_BOOKKEEPING_PLUS,
  BOOKS_PLUS_PLAN,
  MONTHLY_BOOKKEEPING,
  NO_SUBSCRIPTION,
} from "constants/subscriptionType";
import { ALL, ARCHIVED, COMPLETED, ONGOING } from "constants/task";
import * as TAX_STATUSES from "constants/tax";
import { OVERDUE } from "constants/complianceMonthStatuses";
import { HOLIDAY, SLA, TIMED, WEEKEND } from "constants/chatSettingBannerTypes";
import {
  CHECKLIST_ITEM_TYPE,
  CLOSING_STATUS,
} from "constants/financialClosing";
import { INVOICE_STATUSES } from "constants/invoicing";

type CardType = {
  [key: string]: string;
  discover: string;
  mastercard: string;
  amex: string;
  jcb: string;
  unionpay: string;
  visa: string;
  default: string;
};

const NOT_STARTED_CONST = NOT_STARTED;

export let TASK_STATE_TO_COLOR = {
  [UPLOAD_DOCUMENTS]: "yellow",
  [SUBMITTED]: "green",
  [FORM_FILING]: "red",
  [FILING_IN_PROGRESS]: "yellow",
  [REVIEW]: "yellow",
  [NOT_STARTED_CONST]: "red",
  [ARCHIVED]: "neutral",
};

export let GROUP_REQUEST_STATE_TEXT = {
  [INITIATED]: "Requested!",
  [REJECTED_REQUEST]: "Admin Rejected!",
  [NOT_INITIATED]: "Request to Join",
  [ADMIN_APPROVED]: "Joined!",
};

export const REPLY_MESSAGE_TYPE = {
  [TXN_CLARIFICATION_CARD]: REPLY_TXN_CLARIFICATION_CARD,
  [REQUEST_TXN_INVOICE]: REPLY_REQUEST_TXN_INVOICE,
  [REPLY_TXN_CLARIFICATION_CARD]: REPLY_TXN_CLARIFICATION_CARD,
  [REPLY_REQUEST_TXN_INVOICE]: REPLY_REQUEST_TXN_INVOICE,
};

export const SUBSCRIPTION_TYPE = {
  [STANDARD_PLAN]: "purple",
  [PRO_PLAN]: "orange",
  [FREE_PLAN]: "neutral",
};

export const CRM_SUBSCRIPTION_TYPE = {
  [STANDARD]: "purple",
  [PRO]: "orange",
  [PAYG]: "light-green",
  [BYOA]: "blue70",
};

export type CrmSubscriptionType = keyof typeof CRM_SUBSCRIPTION_TYPE;

export const REFERRAL_STATUS = {
  [INVITED]: "ongoing",
  [SIGNED_UP]: "ongoing",
  [SUBSCRIBED]: "completed",
};

export const REWARD_STATUS = {
  [PENDING]: "ongoing",
  [SENT]: "completed",
};

export const BOOKS_STATUS = {
  [BOOKKEEPIN_SUMMAY_STATUSES.NOT_STARTED]: "Upcoming",
  [BOOKKEEPIN_SUMMAY_STATUSES.COMPLETED]: "Done",
  [BOOKKEEPIN_SUMMAY_STATUSES.IN_PROGRESS]: "Ongoing",
  [BOOKKEEPIN_SUMMAY_STATUSES.IN_CLIENT_REVIEW]: "Review Pending",
  [BOOKKEEPIN_SUMMAY_STATUSES.IN_CPA_REVIEW]: "Review Pending",
  [BOOKKEEPIN_SUMMAY_STATUSES.BANK_CONNECT]: "No accounts connected",
  [BOOKKEEPIN_SUMMAY_STATUSES.NOT_APPLICABLE]: "Not applicable",
  [BOOKKEEPIN_SUMMAY_STATUSES.SEASON]:
    "Choose what timeline you'd like us to follow for your books",
  [BOOKKEEPIN_SUMMAY_STATUSES.PLATFORM]:
    "Choose and add our bookkeepers to your preferred platform",
};

export const BOOKS_SUBSCRIPTION = {
  STANDARD: "Standard",
  PRO: "Pro",
  PAYG: "PAYG",
  BYOA: "BYOA",
};
export const BOOKS_SUBSCRIPTION_VALUES = {
  STANDARD: "Standard",
  PRO: "Pro",
  PAYG: "PAYG",
  BYOA: "BYOA",
};

export const BOOKS_STATUS_TYPE = {
  [BOOKKEEPIN_SUMMAY_STATUSES.NOT_STARTED]: "PROCESSING",
  [BOOKKEEPIN_SUMMAY_STATUSES.COMPLETED]: "COMPLETED",
  [BOOKKEEPIN_SUMMAY_STATUSES.IN_PROGRESS]: "FORM_FILING",
  [BOOKKEEPIN_SUMMAY_STATUSES.IN_CLIENT_REVIEW]: "ACTION_REQUIRED",
  [BOOKKEEPIN_SUMMAY_STATUSES.IN_CPA_REVIEW]: "ACTION_REQUIRED",
  [BOOKKEEPIN_SUMMAY_STATUSES.NOT_APPLICABLE]: "PROCESSING",
};

export const TASK_LIST_FILTER_TYPES = {
  [ONGOING]: { showOngoing: true },
  [COMPLETED]: { showFinished: true },
  [ARCHIVED]: { showArchive: true },
  [ALL]: {
    showArchive: true,
    showOngoing: true,
    showFinished: true,
  },
};

export const SERVICE_LIST_FILTER_TYPES = {
  [ONGOING]: { showOngoing: true },
  [COMPLETED]: { showFinished: true },
  [ALL]: {
    showOngoing: true,
    showFinished: true,
  },
};

export const BOOKS_SEASON_SUMMARY_STATUS = {
  [BOOKKEEPIN_SUMMAY_STATUSES.NOT_STARTED]: "neutral",
  [BOOKKEEPIN_SUMMAY_STATUSES.IN_PROGRESS]: "yellow",
  [BOOKKEEPIN_SUMMAY_STATUSES.IN_CPA_REVIEW]: "red",
  [BOOKKEEPIN_SUMMAY_STATUSES.COMPLETED]: "green",
};

export const FILING_STATES = {
  [TAX_STATUSES.ACTION_REQUIRED]: "Action Required",
  [TAX_STATUSES.WITH_INKLE]: "With Inkle",
  [TAX_STATUSES.COMPLETED]: "Completed",
  [TAX_STATUSES.ACTIVE]: "Active",
};

export const BILLING_INFO_PLAN_DESCRIPTION = {
  [PRO]: "Monthly expense based slabs",
  [PAYG]: "$100/ year (covers upto 100 txn and $1/txn thereafter)",
  [BYOA]: "Monthly review of financials",
};

export const ESIGN_ITEM_TAG_TYPE = {
  REQUESTED: "gray",
  SUBMITTED: "green",
  PROCESSING: "yellow",
};

export const ESIGN_ITEM_STATUS = {
  REQUESTED: "REQUESTED",
  SUBMITTED: "COMPLETED",
  PROCESSING: "PROCESSING",
};

export const BankLogos: CardType = {
  discover: Discover,
  mastercard: MasterCard,
  amex: AmEx,
  jcb: JCB,
  unionpay: UnionPay,
  visa: Visa,
  default: DefaultBankLogo,
};

export const TxnSource = {
  CSV: "CSV",
  INKLE_BOOKS: "Inkle Books",
  MANUAL: "Manual",
};

export const BILLING_CYCLE = {
  [BILLING_CYCLES.MONTHLY]: "month",
  [BILLING_CYCLES.YEARLY]: "year",
  [BILLING_CYCLES.QUARTERLY]: "quarter",
};

export const REPORT_INFO = {
  [BALANCE_SHEET]:
    "A balance sheet is a financial statement that summarizes a company's assets, liabilities, and equity at a specific point in time, providing a snapshot of its financial position.",

  [INCOME_STATEMENT]:
    "An income statement, also known as a profit and loss statement, is a financial report that presents a summary of a company's revenues, expenses, and net income over a specific period, reflecting its profitability.",

  [CASH_FLOW_STATEMENT]: "",
};

export const REPORT_TYPE: { [key: string]: string } = {
  [BALANCE_SHEET]: "Balance Sheet",
  [INCOME_STATEMENT]: "Income Statement",
  [CASH_FLOW_STATEMENT]: "Cash Flow Statement",
  [SAVED_REPORTS]: "Saved Reports",
};

export const REPORT_FILE_TYPE = {
  [BALANCE_SHEET]: "balance_sheet",
  [INCOME_STATEMENT]: "profit_loss_statement",
  [CASH_FLOW_STATEMENT]: "cash_flow_statement",
};

export const ASSOCIATED_TYPE = {
  [ASSET]: "Asset",
  [LIABILITY]: "Liability",
  [EQUITY]: "Equity",
  [REVENUE]: "Revenue",
  [EXPENSE]: "Expense",
};

export const TRANSACTION_SOURCE = {
  JOURNAL_ENTRY: "Manual Entry",
  PLAID: "Plaid",
  BANK_STATEMENT: "Bank Statement",
  DIRECT_CONNECT: "Direct Connect",
  LEDGER_ENTRY: "Journal Entry",
};

export const CONNECTION_TYPE = {
  PLAID: " (Via Plaid)",
  MANUAL: " (Manually added)",
  DIRECT: "",
};

export const CRM_SUBSCRIPTION_BADGE_MAP = {
  [PRO]: "P",
  [STANDARD]: "S",
  [PAYG]: "PAYG",
  [BYOA]: "BYOA",
};

export const CRM_SUBSCRIPTION_TYPES = [
  PRO,
  STANDARD,
  FREE,
  UNSUBSCRIBED,
  OVERDUE,
  PAYG,
  BYOA,
  RA,
  MAILROOM,
  BOOKS_PLUS_PLAN,
  MONTHLY_BOOKKEEPING,
  MONTHLY_BOOKKEEPING_PLUS,
  NO_SUBSCRIPTION,
];

export const CRM_SUBSCRIPTION_TYPE_OPTIONS = [
  { value: NO_SUBSCRIPTION, label: "No Subscription" },
  { value: PRO, label: "Pro" },
  { value: STANDARD, label: "Standard" },
  { value: PAYG, label: "PAYG" },
  { value: BYOA, label: "BYOA" },
  { value: RA, label: "RA" },
  { value: MAILROOM, label: "Mailroom" },
  { value: BOOKS_PLUS_PLAN, label: "Books Plus Plan" },
  { value: MONTHLY_BOOKKEEPING, label: "Monthly Bookkeeping" },
  { value: MONTHLY_BOOKKEEPING_PLUS, label: "Monthly Bookkeeping Plus" },
];

export const ACCOUNTING_METHOD = {
  [ACCOUNTING_METHODS.CASH]: "Cash method",
  [ACCOUNTING_METHODS.ACCRUAL]: "Accrual method",
};

export const ACCOUNTING_METHODS_MAP = {
  [ACCOUNTING_METHODS.CASH]: "Cash",
  [ACCOUNTING_METHODS.ACCRUAL]: "Accrual",
};

export const INVOICE_STATUS_TITLE = {
  [INVOICE_STATUSES.DRAFT]: "Draft",
  [INVOICE_STATUSES.PAID]: "Paid",
  [INVOICE_STATUSES.DUE]: "Due",
  [INVOICE_STATUSES.OVERDUE]: "Overdue",
};

export const CHAT_SETTING_BANNER_TYPE_DICT = {
  [SLA]: "Default",
  [WEEKEND]: "Weekends",
  [HOLIDAY]: "Holidays",
  [TIMED]: "Timed banner",
};

export const REGISTRATION_TYPE = {
  HOME_STATE: "Home State",
  FOREIGN_QUALIFICATION: "Foreign Qualification",
  NOT_SPECIFIED: "",
};

export const REGISTRATION_TYPE_BADGE = {
  HOME_STATE: "purple",
  FOREIGN_QUALIFICATION: "light_grey",
  NOT_SPECIFIED: "",
};

export const TEAM_SETTINGS_INVITE_STATUS = {
  NOT_VERIFIED: "Not Verified",
  INVITED: "Invited",
  JOINED: "Active",
  ADMIN_APPROVED: "Active",
  ARCHIVED: "Archived",
  ADMIN_REJECTED: "Inactive",
  INITIATED: "Approval pending",
};

export const TEAM_SETTINGS_INVITE_STATUS_COLOR = {
  NOT_VERIFIED: "neutral",
  INVITED: "gray",
  JOINED: "green",
  ADMIN_APPROVED: "green",
  ARCHIVED: "transparent",
  ADMIN_REJECTED: "transparent",
  INITIATED: "orange",
};

export const BILLING_INVOICE_STATUS = {
  PENDING: "Unpaid",
  PAID: "Paid",
};

export const PRODUCT_SERVICE_ITEM_TYPE: Record<ItemType, string> = {
  [ITEM_TYPES.PRODUCT]: "Product",
  [ITEM_TYPES.SERVICE]: "Service",
};

export const FINANCIAL_CLOSING_CHECKLIST_TOOLTIP_TEXT = {
  [CHECKLIST_ITEM_TYPE.ACCOUNT]:
    "Accounts with non-zero difference indicate mismatch between Inkle balance and bank balance, and therefore need to be reconciled. Accounts with no difference are marked as auto-complete by the system.",
  [CHECKLIST_ITEM_TYPE.CATEGORIZATION]:
    "Uncategorized transactions from the selected period are required to be categorized for accurate financials.",
  [CHECKLIST_ITEM_TYPE.REVIEW_PENDING_BANK_TRANSFERS]:
    "Pending bank transfers are transfers that were initiated/received outside the selected period, and therefore need to be recategorized.",
  [CHECKLIST_ITEM_TYPE.REVIEW_PENDING_CARD_PAYMENTS]:
    "Pending card payments are payments that were initiated/received outside the selected period, and therefore need to be recategorized.",
  [CHECKLIST_ITEM_TYPE.REVIEW_VENDORS]:
    "New vendors from the the selected period should be reviewed to verify the name, categorization, and that these are not duplicates.",
  [CHECKLIST_ITEM_TYPE.REVIEW_FIXED_ASSETS]:
    "New fixed assets from the the selected period should be reviewed to verify whether they are categorized accurately.",
  [CHECKLIST_ITEM_TYPE.REVIEW_JOURNAL_ENTRIES]:
    "Journal entries created within the selected period should be reviewed to verify whether they are added accurately.",
  [CHECKLIST_ITEM_TYPE.REVIEW_BALANCE_SHEET]: null,
  [CHECKLIST_ITEM_TYPE.REVIEW_CASHFLOW_STATEMENT]: null,
  [CHECKLIST_ITEM_TYPE.REVIEW_INCOME_STATEMENT]: null,
};

export const FINANCIAL_CLOSING_CHECKLIST_LABEL = {
  [CHECKLIST_ITEM_TYPE.ACCOUNT]: "Reconcile accounts",
  [CHECKLIST_ITEM_TYPE.CATEGORIZATION]: "Categorize uncategorized transactions",
  [CHECKLIST_ITEM_TYPE.REVIEW_PENDING_BANK_TRANSFERS]:
    "Recategorize pending bank transfers",
  [CHECKLIST_ITEM_TYPE.REVIEW_PENDING_CARD_PAYMENTS]:
    "Recategorize pending card payments",
  [CHECKLIST_ITEM_TYPE.REVIEW_VENDORS]: "Review new vendors",
  [CHECKLIST_ITEM_TYPE.REVIEW_FIXED_ASSETS]: "Review new fixed assets",
  [CHECKLIST_ITEM_TYPE.REVIEW_JOURNAL_ENTRIES]: "Review journal entries",
  [CHECKLIST_ITEM_TYPE.REVIEW_BALANCE_SHEET]: "Review Balance Sheet",
  [CHECKLIST_ITEM_TYPE.REVIEW_CASHFLOW_STATEMENT]: "Review Cash Flow Statement",
  [CHECKLIST_ITEM_TYPE.REVIEW_INCOME_STATEMENT]: "Review Income Statement",
};

export const FINANCIAL_CLOSING_ACTION_NAME = {
  [CLOSING_STATUS.COMPLETED]: "",
  [CLOSING_STATUS.IN_PROGRESS]: "Ready for review",
  [CLOSING_STATUS.REVIEW_PENDING]: "Finalise financials",
  [CLOSING_STATUS.REJECTED]: "",
  [CLOSING_STATUS.REQUEST_CHANGES]: "",
  [CLOSING_STATUS.AMENDED]: "",
  [CLOSING_STATUS.PENDING_INFO]: "Ready for review",
};

export const REVIEW_CHANGES_LINK = {
  [CHECKLIST_ITEM_TYPE.REVIEW_FIXED_ASSETS]: "/books/fixed-assets",
  [CHECKLIST_ITEM_TYPE.REVIEW_JOURNAL_ENTRIES]:
    "/books/categories/journalentry",
  [CHECKLIST_ITEM_TYPE.REVIEW_VENDORS]: "/books/bills-and-vendors",
};

export const REPORT_FINANCIALS_MAP = {
  [CHECKLIST_ITEM_TYPE.REVIEW_CASHFLOW_STATEMENT]: CASH_FLOW_STATEMENT,
  [CHECKLIST_ITEM_TYPE.REVIEW_BALANCE_SHEET]: BALANCE_SHEET,
  [CHECKLIST_ITEM_TYPE.REVIEW_INCOME_STATEMENT]: INCOME_STATEMENT,
};

export const REPORT_NAME = {
  [CHECKLIST_ITEM_TYPE.REVIEW_CASHFLOW_STATEMENT]: "Cash Flow Statement",
  [CHECKLIST_ITEM_TYPE.REVIEW_BALANCE_SHEET]: "Balance Sheet",
  [CHECKLIST_ITEM_TYPE.REVIEW_INCOME_STATEMENT]: "Income Statement",
  AR_AGING: "AR Aging",
  AP_AGING: "AP Aging",
  VENDOR_SUMMARY: "Vendor Summary",
};

export const BILLING_CYCLE_LABELS: Record<string, string> = {
  [YEARLY]: "Yearly",
  [MONTHLY]: "Monthly",
  [QUARTERLY]: "Quarterly",
};
